document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);

  let view = params.get("view");
  const variant = params.get("variant");
  if (!view) {
    const prSeq = params.get("pr_seq");
    if (prSeq && prSeq.includes("?view=")) {
      view = prSeq.split("?view=")[1].split("&")[0];
    }
  }
  if ((view !== "stock-popup" && view !== "back-popup") || !variant) return;

  const variantId = parseInt(variant, 10);
  let variantSelected = false;
  let bisClicked = false;

  const trySelectVariant = () => {
    if (variantSelected) return true;
    const inputs = document.querySelectorAll("variant-selects input");
    for (const input of inputs) {
      const id = parseInt(input.getAttribute("data-id") || input.value, 10);
      if (id === variantId) {
        const wasDisabled = input.disabled;
        if (wasDisabled) input.disabled = false;
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        if (wasDisabled) input.disabled = true;
        variantSelected = true;
        return true;
      }
    }
    return false;
  };

  const tryClickBis = () => {
    if (bisClicked) return true;
    const btn = document.querySelector(
      ".Vtl-BackInStockButtonWrapper .Vtl-BackInStockButton"
    );
    if (btn && btn.offsetParent !== null) {
      btn.click();
      bisClicked = true;
      return true;
    }
    return false;
  };

  const observer = new MutationObserver(() => {
    if (variantSelected && bisClicked) {
      observer.disconnect();
      return;
    }

    const selected = variantSelected || trySelectVariant();
    const clicked = bisClicked || tryClickBis();
    if (selected && clicked) observer.disconnect();
  });

  const initialSelected = trySelectVariant();
  const initialClicked = tryClickBis();
  if (!(initialSelected && initialClicked)) {
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 8000);
  }
});